import { useState, useEffect } from "react"
import { Link } from "react-router-dom"

const AboutUsSection = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [activeHighlight, setActiveHighlight] = useState(0)
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })

  useEffect(() => {
    setIsVisible(true)
    const interval = setInterval(() => {
      setActiveHighlight((prev) => (prev + 1) % 3)
    }, 3000)
    
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY })
    }
    
    window.addEventListener('mousemove', handleMouseMove)
    
    return () => {
      clearInterval(interval)
      window.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])

  const highlights = [
    { 
      icon: "📊", 
      text: "Data-driven & result-oriented approach",
      subtitle: "Analytics-powered strategies for maximum ROI"
    },
    { 
      icon: "🏆", 
      text: "10+ years combined team experience",
      subtitle: "Proven track record across industries"
    },
    { 
      icon: "📈", 
      text: "Transparent reporting & communication",
      subtitle: "Real-time insights and regular updates"
    },
  ]

  return (
    <div
      className="position-relative overflow-hidden"
      style={{
        background: 'white',
        minHeight: "100vh",
      }}
    >
      {/* Animated Background Elements */}
      <div 
        className="position-absolute w-100 h-100"
        style={{
          background: `radial-gradient(circle at ${mousePosition.x/10}% ${mousePosition.y/10}%, rgba(0,0,0,0.05) 0%, transparent 50%)`,
          transition: 'background 0.3s ease'
        }}
      />
      
      {/* Floating Particles */}
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="position-absolute"
          style={{
            width: `${20 + i * 10}px`,
            height: `${20 + i * 10}px`,
            background: 'rgba(0,0,0,0.05)',
            borderRadius: '50%',
            top: `${20 + i * 15}%`,
            left: `${10 + i * 15}%`,
            animation: `float ${3 + i * 0.5}s ease-in-out infinite alternate`,
            backdropFilter: 'blur(10px)'
          }}
        />
      ))}

      <div className="container py-5" style={{ position: "relative", zIndex: 2 }}>
        <div className="row align-items-center min-vh-100">
          {/* Left Side - Content */}
          <div className="col-lg-6 col-md-12 mb-5 mb-lg-0">
            <div
              style={{
                transform: isVisible ? "translateY(0)" : "translateY(60px)",
                opacity: isVisible ? 1 : 0,
                transition: "all 1s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              {/* Animated Badge */}
              <div
                className="d-inline-block mb-4"
                style={{
                  background: "rgba(0,0,0,0.1)",
                  color: "black",
                  fontSize: "14px",
                  padding: "12px 24px",
                  borderRadius: "50px",
                  border: "2px solid rgba(0,0,0,0.2)",
                  backdropFilter: "blur(20px)",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  position: "relative",
                  overflow: "hidden"
                }}
              >
                <div
                  className="position-absolute top-0 start-0 h-100"
                  style={{
                    width: "100%",
                    background: "linear-gradient(90deg, transparent, rgba(0,0,0,0.1), transparent)",
                    animation: "shimmer 2s infinite"
                  }}
                />
                Digital Marketing Excellence
              </div>

              {/* Main Heading */}
              <h1
                className="display-3 fw-bold mb-4"
                style={{
                  color: "black",
                  lineHeight: "1.1",
                  textShadow: "none"
                }}
              >
                Who We Are
              </h1>

              {/* Subtitle with Gradient */}
              <div
                className="mb-4"
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "300",
                  color: "black",
                  lineHeight: "1.6"
                }}
              >
                Transforming brands through innovative digital strategies
              </div>

              {/* Main Description */}
              <p
                className="lead mb-4"
                style={{
                  color: "black",
                  fontSize: "1.2rem",
                  lineHeight: "1.8"
                }}
              >
                We are a full-service digital marketing agency dedicated to helping brands dominate the digital space.
                With a passionate team of strategists, designers, and content creators, we craft campaigns that deliver
                measurable results.
              </p>

              <p
                className="mb-5"
                style={{
                  color: "black",
                  fontSize: "1.1rem",
                  lineHeight: "1.7"
                }}
              >
                Since our inception, we've partnered with startups, SMEs, and global brands to accelerate their growth
                using cutting-edge marketing strategies and innovative technologies.
              </p>

              {/* Enhanced CTA Button */}
              <button
                className="btn btn-lg px-5 py-3 position-relative overflow-hidden"
                style={{
                  background: "linear-gradient(135deg, #ff6b6b 0%, #ffa726 50%, #ff8a65 100%)",
                  border: "none",
                  borderRadius: "50px",
                  color: "white",
                  fontWeight: "700",
                  fontSize: "1.1rem",
                  boxShadow: "0 15px 35px rgba(255, 107, 107, 0.4)",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  textTransform: "uppercase",
                  letterSpacing: "1px"
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = "translateY(-3px) scale(1.05)"
                  e.target.style.boxShadow = "0 20px 45px rgba(255, 107, 107, 0.6)"
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = "translateY(0) scale(1)"
                  e.target.style.boxShadow = "0 15px 35px rgba(255, 107, 107, 0.4)"
                }}
              >
                <Link to="/contact"><span className="position-relative z-3">Start Your Journey</span>
                </Link>
                <div
                  className="position-absolute top-0 start-0 w-100 h-100"
                  style={{
                    background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
                    transform: "translateX(-100%)",
                    animation: "slideRight 3s infinite"
                  }}
                />
              </button>
            </div>
          </div>

          {/* Right Side - Interactive Highlights */}
          <div className="col-lg-6 col-md-12">
            <div
              style={{
                transform: isVisible ? "translateX(0)" : "translateX(60px)",
                opacity: isVisible ? 1 : 0,
                transition: "all 1s cubic-bezier(0.4, 0, 0.2, 1) 0.3s",
              }}
            >
           

              {/* Enhanced Highlights */}
              <div className="row g-4">
                {highlights.map((highlight, index) => (
                  <div key={index} className="col-12">
                    <div
                      className="position-relative"
                      style={{
                        background: activeHighlight === index 
                          ? "rgba(0,0,0,0.1)" 
                          : "rgba(0,0,0,0.05)",
                        backdropFilter: "blur(20px)",
                        border: `2px solid ${activeHighlight === index 
                          ? "rgba(0,0,0,0.2)" 
                          : "rgba(0,0,0,0.1)"}`,
                        borderRadius: "20px",
                        padding: "24px",
                        cursor: "pointer",
                        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        transform: activeHighlight === index ? "scale(1.05) translateY(-5px)" : "scale(1)",
                        boxShadow: activeHighlight === index 
                          ? "0 20px 40px rgba(0,0,0,0.2)" 
                          : "0 10px 20px rgba(0,0,0,0.1)",
                        overflow: "hidden"
                      }}
                      onMouseEnter={() => setActiveHighlight(index)}
                    >
                      {/* Background Glow Effect */}
                      {activeHighlight === index && (
                        <div
                          className="position-absolute top-0 start-0 w-100 h-100"
                          style={{
                            background: "linear-gradient(135deg, rgba(255,107,107,0.1) 0%, rgba(255,167,38,0.1) 100%)",
                            animation: "pulse 2s infinite"
                          }}
                        />
                      )}
                      
                      <div className="d-flex align-items-start position-relative z-2">
                        <div
                          className="me-4 d-flex align-items-center justify-content-center"
                          style={{
                            fontSize: "2.5rem",
                            width: "60px",
                            height: "60px",
                            background: activeHighlight === index
                              ? "linear-gradient(135deg, #ff6b6b, #ffa726)"
                              : "rgba(0,0,0,0.1)",
                            borderRadius: "15px",
                            transform: activeHighlight === index ? "scale(1.1) rotate(5deg)" : "scale(1)",
                            transition: "all 0.3s ease",
                            backdropFilter: "blur(10px)"
                          }}
                        >
                          {highlight.icon}
                        </div>
                        <div className="flex-grow-1">
                          <h5
                            className="mb-2 fw-bold"
                            style={{
                              color: "black",
                              fontSize: "1.2rem"
                            }}
                          >
                            {highlight.text}
                          </h5>
                          <p
                            className="mb-0"
                            style={{
                              color: "rgba(0,0,0,0.7)",
                              fontSize: "0.95rem",
                              lineHeight: "1.5"
                            }}
                          >
                            {highlight.subtitle}
                          </p>
                        </div>
                      </div>
                      
                      {/* Active Indicator */}
                      {activeHighlight === index && (
                        <div
                          className="position-absolute top-0 start-0"
                          style={{
                            width: "4px",
                            height: "100%",
                            background: "linear-gradient(135deg, #ff6b6b, #ffa726)",
                            borderTopLeftRadius: "20px",
                            borderBottomLeftRadius: "20px"
                          }}
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>

  
            </div>
          </div>
        </div>
      </div>

   
    </div>
  )
}

export default AboutUsSection